import approvalDeleteInput from './saveInputs/approvalDeleteInput';

export default (approval) => {
  console.log(
    '[DeleteApprovalMutation] Building GraphQL mutation for approval:',
    approval,
  );
  console.log('[DeleteApprovalMutation] Approval ID:', approval?.id);

  const mutation = `
    deleteDrugApprovalHistory (history: {
        ${approvalDeleteInput(approval)}
    })
`;

  console.log('[DeleteApprovalMutation] Generated GraphQL mutation:', mutation);
  return mutation;
};
